import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SocialSharing from "./socialmediashare";
//import Customad from './customad';
import Mobilead from "./mobilead";
import DOMPurify from "dompurify";

function Sectionlead(props) {
  const [items, setItems] = useState([]);
  let baseurl = window.location.origin;

  const [touchPosition, setTouchPosition] = useState(null);
  const [pos, setPos] = useState(0);
  const [dots, setDots] = useState({ a: "1" });

  //console.log(pos)
  const prevHandler = (e) => {
    e.preventDefault();
    if (pos > 0) {
      setPos((prevPos) => prevPos - 1);
    }
  };

  const nextHandler = (e) => {
    e.preventDefault();
    if (pos < items.length / 2 - 1) {
      setPos((prevPos) => prevPos + 1);
    }
    //console.log(pos)
  };

  const Builddots = () => {
    //let dots = '<span style={{backgroundColor:"#cccccc", display:"inline-flex", margin: "2px", width: "5px", height: "5px", borderRadius: "200%"}}></span>'
    for (let i = 1; i < items.length / 2; i++) {
      //setDots(prevDots=> {return{...prevDots,{i:i}}})
    }

    //return <div>{dots}</div>
  };

  const handleTouchStart = (e) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
    //console.log(touchPosition)
  };

  const handleTouchMove = (e) => {
    const touchDown = touchPosition;
    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      nextHandler();
    }

    if (diff < -5) {
      prevHandler();
    }

    setTouchPosition(null);
  };

  const leadcat =
    props.category === "business"
      ? "HP business 1,HP business 2"
      : props.category === "lifestyle"
      ? "HP lifestyle 1,HP lifestyle 2"
      : props.category === "entertainment"
      ? "HP entertainment 1,HP entertainment 2,HP entertainment 3"
      : props.category === "news"
      ? "HP news 1,HP news 2"
      : props.category === "opinion"
      ? "HP opinion 1, HP opinion 2"
      : props.category === "sports"
      ? "HP sports 1,HP sports 2"
      : "top story";
  // let pagecount = (leadcat === "top story") ? 1 : 2;

  const fetchnews = async () => {
    //const data = await fetch('https://www.myjoyonline.com/wp-json/wp/v2/posts?per_page=10&orderby=date&sort=desc&status=publish');
    const data = await fetch(
      "https://www.myjoyonline.com/wp-json/mjo/v1/lateststories?page=6&order_by=date&sort=desc&status=publish&category=" +
        leadcat,
    );
    const itemss = await data.json();

    setItems(itemss);
  };

  useEffect(() => {
    fetchnews();
    Builddots();
    console.log(dots);
  }, [leadcat]);

  if (items.length > 1) {
    return (
      <div
        style={{
          backgroundColor: "#ffffff",
          maxWidth: "600px",
          padding: "20px 20px 20px 15px",
          borderBottom: "1px solid #eeeeee",
          overflow: "hidden",
          position: "relative",
          margin: "0px auto 20px auto",
        }}
        className="sd"
      >
        <div
          style={{
            position: "absolute",
            top: "37%",
            width: "100%",
            color: "#ffffff",
            zIndex: "50",
          }}
          className="slidecontrolls"
        >
          <Link to={{ pathname: "#" }} className="prev" onClick={prevHandler}>
            <i class="fa-solid fa-angle-left"></i>
          </Link>
          <Link to={{ pathname: "#" }} className="next" onClick={nextHandler}>
            <i class="fa-solid fa-angle-right"></i>
          </Link>
        </div>
        <div className="disable-scrollbars">
          <div className="mb-swipe">
            <div
              style={{
                width: items.length * 230,
                position: "relative",
                transition: "all 0.2s",
                transform: `translateX(${-(pos * 430)}px)`,
              }}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
            >
              {items.map((item, index) => {
                return (
                  <div
                    className="recommendedcontainer"
                    style={{
                      backgroundImage: "url(" + item.thumbnail + ")",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      height: "270px",
                      width: "200px",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-end" }}>
                      <Link
                        to={{
                          pathname: item.slug,
                          state: { category: "none" },
                        }}
                      >
                        <div
                          className="recommendedtitle"
                          style={{ borderRadius: "10px" }}
                        >
                          {item.title}
                        </div>
                        <div className="recommendedoverlay">
                          <img
                            src={item.largeimage}
                            alt={item.title}
                            width="150%"
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div
          style={{
            marginTop: "10px",
            textAlign: "center",
            float: "left",
            width: "100%",
          }}
        >
          {/* {
        dots.map((dot,index)=>{

          return (
          <span style={{backgroundColor:"#cccccc", display:"inline-flex", margin: "2px", width: "5px", height: "5px", borderRadius: "200%"}}></span>
        )
      
      })
      } */}
        </div>
        <Mobilead
          slot="/1002554/Myjoyonline/myjoyonline_home_feed_top"
          id="myjoyonline_home_feed_top"
        />
      </div>
    );
  } else {
    return (
      <div style={{ width: "100%", borderRadius: "10px" }}>
        <div className="topstory" style={{ border: "none" }}>
          <Link to={{ pathname: items.slug, state: { category: "category" } }}>
            <div className="row">
              <div
                className="col-md-12 col-lg-4 col-sm-12"
                style={{ textAlign: "center" }}
              >
                {items.thumbnail != null && (
                  <img src={items.thumbnail} alt={items.title} />
                )}
              </div>

              <div
                className="col-md-12 col-lg-8 col-sm-12"
                style={{
                  paddingLeft: "25px",
                  fontSize: "22px",
                  fontWeight: "600",
                  lineHeight: "1",
                  letterSpacing: "-1px",
                }}
              >
                {items.title}

                <div className="interactiveicons" style={{ marginTop: "20px" }}>
                  <SocialSharing
                    title={items.title}
                    url={baseurl + "/" + items.slug}
                    tags={items.tags}
                  />
                </div>
              </div>
            </div>
          </Link>
        </div>
        {
          // <div className="interactiveicons">
          //   <ShareButtons title={items.title} url={items.permalink} twitterHandle={"_MsLinda"} tags={items.tags}/>
          //   </div>
        }
        <Mobilead
          slot="/1002554/Myjoyonline/myjoyonline_home_feed_top"
          id="myjoyonline_home_feed_top"
        />
      </div>
    );
  }
}

export default Sectionlead;
